import store from '@/store'
// const Guide = () => import("@/views/quiz/Guide.vue")
const MockTest = () => import('@/views/quiz/MockTest.vue')
const MockTestSelectSubject = () => import('@/views/quiz/SelectSubject.vue')
const MockTestQuestions = () => import('@/views/quiz/TheQuestions.vue')
const MockTestResult = () => import('@/views/quiz/Result.vue')


export default
    {
        path: '/quiz',
        component: MockTest,
        children: [
        /*     {
                // path: 'subject?=:subject',
                path: "",
                component: Guide,
                name: "quiz-guide",

            }, */
            {
                path: "",
                name: 'select-subject',
                component: MockTestSelectSubject
            },
            {
                path: ':subject',
                component: MockTestQuestions,
                name: "questions",
                //pervent anyhow exit
       
            },
            {
                path: ':subject/result',
                component: MockTestResult,
                name: "test-result",
                //reroute if no data in local storage return user to select subject
                beforeEnter(to, from, next) {
                    if (!localStorage.getItem("attemptedQuestionsMetaData")) {
                        return next({
                            name: "select-subject"
                        })
                    }
                    next()
                }
            },
        ],
        //return the user to login page if they are not authenticated
        beforeEnter: (from, to, next) => {
            if (!store.getters["auth/authenticated"]) {
                return next({
                    name: "login"
                })
            }
            next()

        }
    }